"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352.41 146.09",
    children: [(0, jsx_runtime_1.jsx)("line", {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "11px",
      x1: "0.03",
      y1: "139.42",
      x2: "70.21",
      y2: "139.42"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "none",
      points: "178.43 124.14 178.43 133.09 226.88 133.09 226.88 109.9 208.25 124.14 178.43 124.14"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "none",
      points: "237.88 101.5 237.88 131.08 341.41 66.26 341.41 15.45 296.52 43.56 306.1 49.38 237.88 101.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      d: "M353.43,227.76a28,28,0,0,0-23.2-12.3l-1,0L318,250Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      d: "M317.69,218.43l-4.47,2.8-20.94,13.11-.53.33,33.58-18.78A27.92,27.92,0,0,0,317.69,218.43Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "none",
      points: "327.79 11 288.53 11 266.05 25.07 285.99 37.17 327.79 11"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "none",
      points: "137.53 27.64 148.53 20.75 162.25 12.16 115.89 12.16 20.72 71.74 67.09 71.74 137.53 27.64"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      d: "M244.7,283l-6.07,3.8a28.38,28.38,0,0,1,6.64,6l2.62-1.64,6.74-4.22a38.92,38.92,0,0,0-4.22-4.75h-4.34Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "none",
      d: "M244.7,243.89l-67.33,42.16,0,0H147.79v44.64l49.81-31.18a28.16,28.16,0,0,1,8.58-11.23l5.08-3.18a27.87,27.87,0,0,1,12.19-2.79c.52,0,1,0,1.55,0l13.08-8.19a39,39,0,0,0-6.25-1.94l12.87-8.06V243.89Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M198.08,322.26l-26.55,16.63,5.84,9.32,27.29-17.09A28.12,28.12,0,0,1,198.08,322.26Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M238.63,286.76l6.07-3.8,1.37-.85h4.34a39.17,39.17,0,0,0-12.33-8L225,282.32A27.8,27.8,0,0,1,238.63,286.76Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M197.6,299.48l-49.81,31.18V286h29.56l0,0,67.33-42.16v20.24l11-6.89V237l24.77-15.51V204.43H219.9l-17.57,11L107.18,275h0v11h29.59v32.7l-29.62,18.55,5.84,9.32,23.78-14.89v11h9.89l.74,1.17,48.2-30.18a26.75,26.75,0,0,1-.21-3.37A27.76,27.76,0,0,1,197.6,299.48ZM127.89,275l95.17-59.59h46.36L255.7,224l-11,6.89L174.25,275Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "167.43 73.64 167.43 73.85 167.43 84.06 173.31 80.38 173.31 78.83 173.31 70.17 167.77 73.64 167.43 73.64"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M247.89,291.08l-2.62,1.64a28.16,28.16,0,0,1,5.11,9.78l9.58-6a38.72,38.72,0,0,0-5.33-9.64Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M269.42,321.85l-35.58,20.93H213.38l-18-12L188.84,307l11-20.91,91.95-51.43.53-.33,20.94-13.11,4.47-2.8a27.92,27.92,0,0,1,7.64-2.54l4.58-2.56-.7,2.16,1,0a28,28,0,0,1,23.2,12.3l9.32-5.83A39,39,0,0,0,307,212.15L205.77,275.53a39,39,0,0,0,9.47,73,38.86,38.86,0,0,0,26.45-3.66,38.11,38.11,0,0,0,4.72-2.95l28.19-17.65v-5.57Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M329.91,213.33l-4.58,2.56a29.14,29.14,0,0,1,3.88-.4Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M261.39,319.52a39,39,0,0,0-29.56-47.33l59.92-37.52L199.8,286.1l-11,20.91,6.57,23.73,18,12h20.46l35.58-20.93,5.18-3.19v-7.41Zm-21.07,13.19-4.12,2.58a28,28,0,0,1-30-47l5.08-3.18a28,28,0,0,1,29.06,47.64Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M452.53,203.28h-60l-17.57,11-12.22,7.65a38.64,38.64,0,0,1,3.3,6.07l3.23-2,3.94,2.39,22.48-14.07H435l-41.8,26.17,10.53,6.39,44.89-28.11v50.81L345.05,334.36V304.77l-11,8.41v23.19H285.6v-9h-7l.84-6.2-4.82,3v23.14h70.45v0l103.53-64.82,11-6.89V203.28Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M314.54,260.59,356.61,234a28.22,28.22,0,0,0-3.18-6.21L318,250Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "207.38 57.31 210.84 46.67 167.77 73.64 167.43 73.64 167.43 73.85 167.43 86.83 167.43 107.97 174.18 103.74 177.96 75.92 207.38 57.31"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M356.61,234l9.44-6a38.64,38.64,0,0,0-3.3-6.07l-9.32,5.83A28.22,28.22,0,0,1,356.61,234Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "173.07 111.91 167.43 115.38 167.43 120.95 172.26 117.93 173.07 111.91"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "167.43 107.97 167.43 115.38 173.07 111.91 174.18 103.74 167.43 107.97"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M373.22,228.35,369.28,226l-3.23,2a37.56,37.56,0,0,1,1.47,3.92Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "204.7 84.64 214.72 78.36 222.27 73.64 202.06 73.64 198.49 84.64 204.7 84.64"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "172.26 117.93 171.41 124.14 178.43 124.14 178.43 114.06 172.26 117.93"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M353.62,274.75a39.93,39.93,0,0,1-5.5,3.44l-15.52,9.72h1.45v25.27l11-8.41V283.55l58.64-36.71-10.53-6.39-26.27,16.44A39.14,39.14,0,0,1,353.62,274.75Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M312.7,266.24l45-28.19a29.26,29.26,0,0,0-1.13-4.08l-42.07,26.62Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polyline", {
      fill: "currentColor",
      points: "205.53 62.97 207.38 57.31 177.96 75.92 174.18 103.74 178.43 101.08 178.43 84.64 198.49 84.64 202.06 73.64 188.5 73.64"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "178.43 108.61 173.07 111.91 172.26 117.93 178.43 114.06 178.43 108.61"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M357.74,238.05l9.78-6.13a37.56,37.56,0,0,0-1.47-3.92l-9.44,6A29.26,29.26,0,0,1,357.74,238.05Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M329.44,276.91l-7.56,4.73-10,6.27H332.6l15.52-9.72a39.93,39.93,0,0,0,5.5-3.44,39.14,39.14,0,0,0,13.27-17.86l-32,20Z",
      transform: "translate(-107.17 -203.28)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      fill: "currentColor",
      points: "178.43 101.08 174.18 103.74 173.07 111.91 178.43 108.61 178.43 101.08"
    })]
  });
};

exports.default = Icon;